export enum GameStates {
  GAME_INIT = "GAME_INIT",
  GAME_PRE_FLOP = "GAME_PRE_FLOP",
  GAME_FLOP = "GAME_FLOP",
  GAME_TURN = "GAME_TURN",
  GAME_RIVER = "GAME_RIVER",
  GAME_RESULT = "GAME_RESULT",
  GAME_RUN = "GAME_RUN",
}

